/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5820ee40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container-grid"
};
import { useAppStore } from '@/store/modules/app';
import LoginTable from './loginTable.vue';
import OrderTable from './orderTable.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const cardHeight = ref(0);
    onMounted(() => {
      const dom = document.querySelector('.container-grid');
      const height = dom === null || dom === void 0 ? void 0 : dom.clientHeight;
      cardHeight.value = height / 2 - 110;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(LoginTable, {
        gameInfo: _unref(gameInfo),
        height: _unref(cardHeight)
      }, null, 8, ["gameInfo", "height"]), _createVNode(OrderTable, {
        gameInfo: _unref(gameInfo),
        height: _unref(cardHeight)
      }, null, 8, ["gameInfo", "height"])]);
    };
  }
});